import { Checkbox } from "../../components/Checkbox";
import { Tooltip } from "../../components/Tooltip";
import { exportFilterStateToSQ } from "../../helpers/dynamicFilterSQ";
import { MainFiltersItem } from "../../models/API";
import { FiltersStateType } from "../../models/filters";
import { Item } from "./Item";

interface MainFiltersProps {
  type: "mobile" | "desktop";
  filters: MainFiltersItem[];
  filtersState: FiltersStateType;
  updateFilters: React.Dispatch<React.SetStateAction<FiltersStateType>>;
}

export const MainFilters: React.FC<MainFiltersProps> = (props) => {
  //
  const toggleFilter = (
    groupId: string,
    id: string,
    activate: boolean,
    radio: boolean = false
  ) => {
    // Prepare new state
    const filterStateAfterChanges = { ...props.filtersState };
    // Check if group is there
    const groupIndex = filterStateAfterChanges.TopSelected.findIndex(
      (x) => x.Key === groupId
    );
    // Check if filter is in group (if group was found)
    const filterIndex =
      groupIndex > -1
        ? filterStateAfterChanges.TopSelected[groupIndex].Checked.findIndex(
            (value) => value === id
          )
        : -1;

    // Manage filter state
    if (groupIndex > -1) {
      // Group is there so take action according to activate
      if (activate) {
        // Add only if its not there
        if (filterIndex < 0) {
          if (radio) {
            filterStateAfterChanges.TopSelected[groupIndex].Checked = [];
          }
          filterStateAfterChanges.TopSelected[groupIndex].Checked.push(id);
        }
      } else {
        if (filterIndex > -1) {
          // Remove filter
          filterStateAfterChanges.TopSelected[groupIndex].Checked.splice(
            filterIndex,
            1
          );
          // Remove group if it's empty
          if (!filterStateAfterChanges.TopSelected[groupIndex].Checked.length) {
            filterStateAfterChanges.TopSelected.splice(groupIndex, 1);
          }
        }
      }
    } else {
      // If group wasn't there we only need add it in case activating filter
      if (activate) {
        filterStateAfterChanges.TopSelected.push({
          Key: groupId,
          Checked: [id],
        });
      }
    }

    exportFilterStateToSQ(filterStateAfterChanges);
    props.updateFilters(filterStateAfterChanges);
  };

  // Just wrapper for radio type filters
  const toggleSingleChoiceFilter = (
    groupId: string,
    id: string,
    activate: boolean
  ) => {
    toggleFilter(groupId, id, activate, true);
  };

  // Returns boolean if element is found in TopSelected filters state
  const checkActive = (groupId: string, id: string) => {
    // Find group in current state
    const currentElementIndex = props.filtersState.TopSelected.findIndex(
      (x) => x.Key === groupId
    );
    if (currentElementIndex >= 0) {
      // Group found so return if value exists in that group
      const currVisibleValues =
        props.filtersState.TopSelected[currentElementIndex].Checked;

      return currVisibleValues.includes(id);
    }

    return false;
  };

  // Desktop filters view
  const renderFilterGroup = (group: MainFiltersItem, index: number) => {
    const isIconInside = group.Values.some((f) => f.IconUrl);

    let className =
      index === 0 ? "markets" : index === 1 ? "groups" : "extra-groups";

    if (index === 0 && !isIconInside) {
      className += " only-text";
    }

    return (
      <div className={className} key={group.Id}>
        {/*<div className="header">
          <h3>{group.Name}</h3>
          {group.IsTooltipVisible && group.TooltipContent && (
            <Tooltip htmlString={group.TooltipContent} />
          )}
          </div>*/}

        {group.Values.map((f) => (
          <Item
            key={f.Id}
            {...f}
            active={checkActive(group.Id, f.Id)}
            groupId={group.Id}
            toggle={
              group.Type === "singleChoice"
                ? toggleSingleChoiceFilter
                : toggleFilter
            }
          />
        ))}
      </div>
    );
  };

  // Mobile filters view
  const renderMobileFilterGroup = (group: MainFiltersItem, index: number) => {
    return (
      <div className="products-group" key={group.Id}>
        <div className="header">
          <h3>{group.Name}</h3>
          {group.IsTooltipVisible && group.TooltipContent && (
            <Tooltip htmlString={group.TooltipContent} />
          )}
        </div>
        <ul>
          {group.Values.map((f) => (
            <Checkbox
              key={f.Id}
              label={f.Text}
              id={f.Id}
              active={checkActive(group.Id, f.Id)}
              groupId={group.Id}
              toggle={
                group.Type === "singleChoice"
                  ? toggleSingleChoiceFilter
                  : toggleFilter
              }
            />
          ))}
        </ul>
      </div>
    );
  };

  return props.type === "desktop" ? (
    <div className="holder-of-main-filter">
      <div className="main-filters">{props.filters.map(renderFilterGroup)}</div>
    </div>
  ) : (
    <div className="products-holder">
      {props.filters.map(renderMobileFilterGroup)}
    </div>
  );
};
